import React from 'react';
import Dialog from 'system/base/Dialog';
import { PrimaryButton, TertiaryButton } from 'system/base/Button';
import { ExtractionFormType } from 'concepts/Extraction/ExtractionFormType';

export type RevisitStudiesDialogProps = {
  inProgress: number;
  completed: number;
  isOpen: boolean;
  onConfirm: (revisitStudies?: boolean) => void;
  onDismiss: () => void;
  formType: ExtractionFormType;
};

export function RevisitStudiesDialog({
  isOpen,
  onConfirm,
  onDismiss,
  formType,
}: RevisitStudiesDialogProps) {
  const pendoKeyYes =
    formType === 'quality_assessment' ? 'qa2-revisit-yes' : 'de2-revisit-yes';
  const pendoKeyNo =
    formType === 'quality_assessment' ? 'qa2-revisit-no' : 'de2-revisit-no';

  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="Would you like reviewers to revisit studies?"
    >
      <p>
        Would you like to move completed extraction forms back to in-progress,
        so reviewers can extract new or updated template items?
      </p>
      <p>Data that has already been extracted will be saved.</p>
      <>
        <PrimaryButton
          mr={2}
          data-pendo-key={pendoKeyYes}
          onClick={() => {
            onConfirm(true);
          }}
        >
          Yes, move studies
        </PrimaryButton>
        <TertiaryButton
          data-pendo-key={pendoKeyNo}
          onClick={() => {
            onConfirm(false);
          }}
        >
          No, don&apos;t move studies
        </TertiaryButton>
      </>
    </Dialog>
  );
}
